import React, { useEffect, useState } from 'react';
import './Ads.css';
import { apiGet } from '../api';

const RightAd = ({ language = 'en' }) => {
  const [ads, setAds] = useState([]);

  useEffect(() => {
    let ignore = false;

    const load = async () => {
      try {
        const hash = window.location.hash || '';
        const m = hash.match(/^#\/blog\/(en|ml)\/(.+)$/);
        let items = [];

        if (m) {
          // Blog detail page: fetch side ads targeted for this post
          const slug = decodeURIComponent(m[2]);
          try {
            const post = await apiGet(`/api/posts/${encodeURIComponent(slug)}`, { locale: language });
            if (post?.id) {
              const resp = await apiGet('/api/ads', { locale: language, zone: 'side_ad', placement: 'blog_detail', postId: String(post.id), limit: 3 });
              items = Array.isArray(resp?.items) ? resp.items : [];
            }
          } catch (_e) { /* ignore */ }
        }

        // Fallback to general blog side ads
        if (!items.length) {
          const resp = await apiGet('/api/ads', { locale: language, zone: 'side_ad', placement: 'blog_all', limit: 3 });
          items = Array.isArray(resp?.items) ? resp.items : [];
        }

        if (!ignore) setAds(items);
      } catch (_) {
        if (!ignore) setAds([]);
      }
    };

    load();
    const onHash = () => { load(); };
    window.addEventListener('hashchange', onHash);
    return () => { ignore = true; window.removeEventListener('hashchange', onHash); };
  }, [language]);

  return (
    <aside className="ad-right" role="complementary" aria-label="Right Sidebar Advertisement">
      {ads.length === 0 ? (
        <div className="ad-label">Display your Ads here</div>
      ) : (
        <div className="ad-right-list">
          {ads.map((ad) => (
            <a key={ad.id} href={ad.ctaUrl || '#'} target={ad.ctaUrl ? '_blank' : undefined} rel={ad.ctaUrl ? 'noopener noreferrer' : undefined} className="ad-card">
              <img src={ad.imageUrl || 'https://via.placeholder.com/300x200/2d5016/ffffff?text=Advertisement'} alt={ad.title || 'Advertisement'} />
              <div className="ad-card-body">
                {ad.adText && <span className="ad-label">{ad.adText}</span>}
                <div className="ad-card-title">{ad.title}</div>
                {ad.ctaText && <div className="ad-card-cta">{ad.ctaText}</div>}
              </div>
            </a>
          ))}
        </div>
      )}
    </aside>
  );
};

export default RightAd;
